import React from 'react';
import { Modal, ModalContent } from '@fiverr-private/overlay';
import { Center } from '@fiverr-private/layout_components';
import { Loader } from '@fiverr-private/feedback';
import { SellerEntityTypes } from '@fiverr-private/upmarket_common';
import { SendTemplateModal } from '../SendTemplate';
import { HandlePaymentRequest, LegalDocsConfigurations } from '../../types';
import { BiData } from '../../biEvents';
import { useTemplatesData } from '../../hooks';
import { RequestToUploadModal } from '../RequestToUploadModal';
import { useSellerConfigData } from '../../hooks/useSellerConfigData';
import { useOrganizationConfigData } from '../../hooks/useOrganizationConfigData';

export interface InitialInteractionActionModalProps {
    sellerName: string;
    sellerId: number;
    handlePayment: HandlePaymentRequest;
    isOpen?: boolean;
    closeModal: () => void;
    biData: BiData;
    sellerEntityType?: SellerEntityTypes;
    wasRedirectedFromUpgrade?: boolean;
}

export const InitialInteractionActionModal = ({
    sellerName,
    sellerId,
    handlePayment,
    isOpen,
    closeModal,
    biData,
    wasRedirectedFromUpgrade,
    sellerEntityType,
}: InitialInteractionActionModalProps) => {
    const { legalDocsConfigurations, isLoading: isLoadingDocConfigs } = useSellerConfigData(sellerId);
    const { sellerDataQuery } = useTemplatesData({ sellerId });
    const { data: organizationData, isLoading: isLoadingOrganizationData } = useOrganizationConfigData();

    const { activeTemplates = 0, totalTemplates = 0 } = organizationData?.legalDocsData || {};

    if (!legalDocsConfigurations || isLoadingDocConfigs || isLoadingOrganizationData) {
        return (
            <Modal>
                <ModalContent>
                    <Center minHeight="400px">
                        <Loader />
                    </Center>
                </ModalContent>
            </Modal>
        );
    }

    if (totalTemplates) {
        return (
            <SendTemplateModal
                wasRedirectedFromUpgrade={wasRedirectedFromUpgrade}
                configurations={legalDocsConfigurations || ({ additionalData: {} } as LegalDocsConfigurations)} // minimal fallback if needed
                sellerName={sellerName}
                sellerId={sellerId}
                onSend={() => sellerDataQuery.refetch()}
                isDisabled={!activeTemplates}
                handlePayment={handlePayment}
                isOpen={isOpen}
                onClose={closeModal}
                biData={biData}
                sellerEntityType={sellerEntityType}
            />
        );
    }

    return <RequestToUploadModal biData={biData} isOpen={isOpen} onClose={closeModal} />;
};
